/* tslint:disable:max-line-length */
import { FuseNavigationItem } from "@fuse/components/navigation";

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: "home",
        title: "Home",
        type: "basic",
        icon: "home",
        link: "/home",
    },
    {
        id: "my-request",
        title: "Requests",
        type: "basic",
        icon: "how_to_reg",
        link: "/requests",
    },
    {
        id: "my-tasks",
        title: "Tasks",
        type: "basic",
        icon: "playlist_add_check",
        link: "/tasks",
    },

    // {
    //     id: "forms",
    //     title: "Forms",
    //     type: "group",
    //     children: [
    //         {
    //             id: "create-form",
    //             title: "Create New Form",
    //             type: "basic",
    //             icon: "create",
    //             link: "/forms/create/-1",
    //         },
    //         {
    //             id: "form-list",
    //             title: "Form List",
    //             type: "basic",
    //             icon: "list",
    //             link: "/forms/list",
    //         },
    //     ],
    // },
    // {
    //     id: "users",
    //     title: "Users",
    //     type: "group",
    //     children: [
    //         {
    //             id: "create-user",
    //             title: "Create New User",
    //             type: "basic",
    //             icon: "account_circle",
    //             link: "/users/create/-1",
    //         },
    //         {
    //             id: "user-list",
    //             title: "User List",
    //             type: "basic",
    //             icon: "assignment_ind",
    //             link: "/users/list",
    //         },
    //     ],
    // },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: "example",
        title: "Example",
        type: "basic",
        icon: "heroicons_outline:chart-pie",
        link: "/example",
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: "example",
        title: "Example",
        type: "basic",
        icon: "heroicons_outline:chart-pie",
        link: "/example",
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: "home",
        title: "Home",
        type: "basic",
        icon: "home",
        link: "/home",
    },
    {
        id: "my-request",
        title: "Requests",
        type: "basic",
        icon: "how_to_reg",
        link: "/requests",
    },
    {
        id: "my-tasks",
        title: "Tasks",
        type: "basic",
        icon: "playlist_add_check",
        link: "/tasks",
    },
    // {
    //     id: "forms",
    //     title: "Forms",
    //     type: "group",
    //     children: [
    //         {
    //             id: "create-form",
    //             title: "Create New Form",
    //             type: "basic",
    //             icon: "create",
    //             link: "/forms/create/-1",
    //         },
    //         {
    //             id: "form-list",
    //             title: "Form List",
    //             type: "basic",
    //             icon: "list",
    //             link: "/forms/list",
    //         },
    //     ],
    // },
    // {
    //     id: "users",
    //     title: "Users",
    //     type: "group",
    //     children: [
    //         {
    //             id: "create-user",
    //             title: "Create New User",
    //             type: "basic",
    //             icon: "account_circle",
    //             link: "/users/create/-1",
    //         },
    //         {
    //             id: "user-list",
    //             title: "User List",
    //             type: "basic",
    //             icon: "assignment_ind",
    //             link: "/users/list",
    //         },
    //     ],
    // },
];
